///////////////////
/// LAZY LOAD /////
///////////////////

$(document).on('lazyloaded', function(e) {
    console.log('** lazyloaded is fired', e.target);
})

$(document).on('lazybeforeunveil', function(e) {

    // console.log('lazyloader baby!', e.target);

    var viewportWidth = $(window).innerWidth();
    // var bg = $(e.target).data('bg-mobile');
    var bg = $(e.target).data('bg-mobile');
    if (viewportWidth > 0) {
        bg = $(e.target).data('bg-mobile');
    }
    if (viewportWidth > 768) {
        bg = $(e.target).data('bg-tablet');
    }
    if (viewportWidth > 1023) {
        bg = $(e.target).data('bg-desktop');
    }
    if (viewportWidth > 1800) {
        bg = $(e.target).data('bg-super');
    }

    if (bg) {
        // $(e.target).css('background-image', 'url(' + bg + ')');
        // TweenMax.set($($(e.target)), {backgroundImage:'url(' + bg + ')'});
        // Also if you're going to use the css wrapper it shoud be like this:
        // TweenMax.set($(e.target),   {opacity:0}); // delay: 1

        // var giveFadeInClass = function(){
        // $(e.target).addClass('fade-in');
        // }

        TweenMax.set($(e.target), { css: { backgroundImage: 'url(' + bg + ')' }, delay: 0.4 }); // onComplete:giveFadeInClass

        // TweenMax.to($(e.target),    0.5,  {opacity:1, delay: 0.5}); // delay: 1

        // // in case of issues with opacity
        // var setOpacityTo1 = function(){
        //   console.log('%c setOpacityTo1 called', 'color: #bada55, background: #000');
        //   console.log($(e.target));
        //   TweenMax.set($(e.target),   {opacity:1});
        // }
        // TweenMax.delayedCall(6, setOpacityTo1);  

    }

});


///////////////////
/// UTILITIES /////
///////////////////

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this,
            args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

var scriptInit = function() {

    /////////////////////////////////////////////////////////////////////////////////////////////
    // Toggle on grid                                                                        / //
    /////////////////////////////////////////////////////////////////////////////////////////////

    window.onkeyup = function(e) {
        var key = e.keyCode ? e.keyCode : e.which;

        if (key == 71) {
            $('html').addClass('show-grid');
        } else if (key == 76) {
            $('html').addClass('show-lines');
        } else if (key == 27) {
            $('html').removeClass('show-grid');
            $('html').removeClass('show-lines');
        }
    }

    /////////////////////////////////////////////////////////////////////////////////////////////
    // Mobile height 100vh fix - https://css-tricks.com/the-trick-to-viewport-units-on-mobile/ //
    /////////////////////////////////////////////////////////////////////////////////////////////

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // We listen to the resize event
    window.addEventListener('resize', () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    ///////////////////////////////
    // LAZY LOAD Sizes in RESIZE //
    ///////////////////////////////

    var onResize = debounce(function() {

        console.log('resize triggered');
        // VARS
        var viewportWidth = $(window).innerWidth();

        /// LAZY SIZES FOR BACKGROUNDS....
        // console.log('onResize fired. viewportWidth is', viewportWidth);
        $.each($(".lazyloaded"), function(index, item) {
            var bg = $(item).data('bg-mobile');
            if (viewportWidth > 0) {
                bg = $(item).data('bg-mobile');
            }
            if (viewportWidth > 768) {
                bg = $(item).data('bg-tablet');
            }
            if (viewportWidth > 1023) {
                bg = $(item).data('bg-desktop');
            }
            if (viewportWidth > 1800) {
                bg = $(item).data('bg-super');
            }
            if (bg) {
                // console.log('lazyloader resize!', $(item), ' - onResize fired. viewportWidth is', viewportWidth);
                $(item).css('background-image', 'url(' + bg + ')');
            }
        });

    }, 250);

    window.addEventListener('resize', onResize);


    $("nav.off-canvas-menu .menu-item-has-children").click(function(event) {
        $(this).toggleClass('is-active');
    });

    ///////////////////
    // MENU TOGGLE.  //
    ///////////////////

    // body.menu-is-open
    $("body .js-menu-toggle").click(function(event) {
        toggleClassMenu();
    });

    var toggleClassMenu = function() {

        $('.js-menu-toggle.hamburger').toggleClass('is-active');
        $('body').toggleClass('menu-is-open');

        var $labelCopy = $('js-hamburger--label').text();
        console.log($labelCopy);
        if ($labelCopy == 'Menu') {
            $('js-hamburger--label').text('Close');
        } else {
            $('js-hamburger--label').text('Menu');
        }

        // console.log('%c menu toggled', 'background:#000; color:#fff');
        // $("body .off-canvas-menu").addClass("off-canvas-menu--animatable");   
        // if(!$("body .off-canvas-menu").hasClass("off-canvas-menu--visible")) {       
        //   $("body .off-canvas-menu").addClass("off-canvas-menu--visible");
        //   $('body').addClass('menu-open');
        //   $('html').addClass('menu-open');
        // } else {
        //   $("body .off-canvas-menu").removeClass('off-canvas-menu--visible');
        //   $('body .off-canvas-news-list').removeClass('off-canvas-news-list--visible');
        //   $('body').removeClass('menu-open');    
        //   $('body').removeClass('news-list-open');

        //   var removeClassFromHTML = function(){
        //     $('html').removeClass('menu-open');  
        //     $("body .off-canvas-menu").removeClass("off-canvas-menu--animatable");
        //   }

        //   TweenMax.delayedCall(0.2, removeClassFromHTML);   
        // }   

    }


    ///////////////////
    // SMOOTH SCROLL //
    ///////////////////

    // Select all links with hashes
    // $('a[href*="#"]')
    //   // Remove links that don't actually link to anything
    //   .not('[href="#"]')
    //   .not('[href="#news"]') // added for news in overlay
    //   .not('[href="#0"]')
    //   .click(function(event) {
    //     // On-page links
    //     if (
    //       location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
    //       && 
    //       location.hostname == this.hostname
    //     ) {
    //       // Figure out element to scroll to
    //       var target = $(this.hash);
    //       target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    //       // Does a scroll target exist?
    //       if (target.length) {
    //         // Only prevent default if animation is actually gonna happen
    //         event.preventDefault();
    //         $('html, body').animate({
    //           scrollTop: target.offset().top
    //         }, 1000, function() {
    //           // Callback after animation
    //           // Must change focus!
    //           var $target = $(target);
    //           $target.focus();
    //           if ($target.is(":focus")) { // Checking if the target was focused
    //             return false;
    //           } else {
    //             $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
    //             $target.focus(); // Set focus again
    //           };
    //         });
    //       }
    //     }
    //   });


};

$(document).ready(function() {

    // ANIMS
    var wow = new WOW({
        boxClass: 'wow', // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset: 25, // distance to the element when triggering the animation (default is 0)
        mobile: true, // trigger animations on mobile devices (default is true)
        live: true, // act on asynchronously loaded content (default is true)
        callback: function(box) {
            // the callback is fired every time an animation is started
            // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null, // optional scroll container selector, otherwise use window,
        resetAnimation: true, // reset animation on end (default is true)
    });
    wow.init();

    // Home Slider
    $('.single-item').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: true,
        fade: true,
        autoplay: false,
        autoplaySpeed: 6000,
        adaptiveHeight: true,
        cssEase: 'linear'
    });





    // ACCORDION
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }

    ////////////////////
    /// SWUP ///////////
    ////////////////////

    // const pageTransitions = function() {
    // let pageTransitioning = false;
    // let animateInTimeline,
    //     animateOutTimeline,
    //     animateInNext;


    // // load scripts for replaced elements
    // document.addEventListener('swup:contentReplaced', event => {
    //   // swup.options.elements.forEach((selector) => {
    //       // load scripts for all elements with 'selector'
    //       // console.log( '%c contentReplaced ' + event.target.URL, 'background: #444; color: #888');
    //       // console.log($('body'));
    //       // scriptInit();
    //   // })
    //   // console.log(event);
    //   // console.log($('body'));

    //   setTimeout(function(){
    //     // console.log( '%c contentReplaced ' + event.target.URL, 'background: #444; color: #888');
    //     console.log($('body'));
    //     scriptInit();
    //   }, 1);

    // });

    // // document.addEventListener('swup:pageRetrievedFromCache', event => {
    // //   console.log( '%c pageRetrievedFromCache -> ' + event.target.URL, 'background: #222; color: #888');
    // //   scriptInit();
    // // });

    // let reverseLoad = () => {
    //     animateInNext && animateInNext();
    // }

    // let buildTimelineOut = (callback) => {
    //     let itemsToAnimate = $(".animate-out").toArray();
    //     itemsToAnimate.reverse();
    //     animateOutTimeline = new TimelineMax({ onComplete: callback });
    //     animateOutTimeline.to(itemsToAnimate, 0.3, { autoAlpha: 0 });
    // }

    // let buildTimelineIn = (callback) => {
    //     let itemsToAnimate = $(".animate-out").toArray();
    //     TweenMax.set(itemsToAnimate, { autoAlpha: 0 });
    //     animateInTimeline = new TimelineMax({ onComplete: callback, onReverseComplete: reverseLoad });
    //     animateInTimeline.to(itemsToAnimate, 0.3, { autoAlpha: 1 });
    // }

    // let options = {
    //   elements: ['#site-content', '#menu-main-menu'],
    //   // debugMode: true,
    //   preload: true,
    //   animateScroll: false,
    //   // pageClassPrefix: 'page-',
    //   animations: {
    //     // if link has data-swup-class="single-work"
    //     // '*>single-work': { 
    //     //   out: function(next) {
    //     //     console.log('%c ---->>>>>>> single work page baby', 'background: #bada55; color: #fff');
    //     //     // if (!pageTransitioning) {
    //     //     animateInNext = next;
    //     //     if (animateInTimeline && animateInTimeline.progress() < 1) {
    //     //       animateInTimeline.reverse();
    //     //     } else {
    //     //       if (!animateOutTimeline) {
    //     //         buildSingleWorkTimelineOut(next);
    //     //       }
    //     //       if (animateOutTimeline && !animateOutTimeline.isActive()) {
    //     //         buildSingleWorkTimelineOut(next);
    //     //       }
    //     //     }
    //     //   },
    //     //   in: function(next) {
    //     //     console.log(next);
    //     //     buildTimelineIn(next);
    //     //   }
    //     // },
    //     /// default transition
    //     '*': {
    //       out: function(next) {
    //         // if (!pageTransitioning) {
    //         animateInNext = next;
    //         if (animateInTimeline && animateInTimeline.progress() < 1) {
    //           animateInTimeline.reverse();
    //         } else {
    //           if (!animateOutTimeline) {
    //             buildTimelineOut(next);
    //           }
    //           if (animateOutTimeline && !animateOutTimeline.isActive()) {
    //             buildTimelineOut(next);
    //           }
    //         }
    //       },
    //       in: function(next) {
    //         console.log(next);
    //         buildTimelineIn(next);
    //       }
    //     }
    //   },
    //   LINK_SELECTOR: 'a[href^="/"]:not(.data-no-swup), a[href^="' + window.location.origin + '"]:not(.data-no-swup)'
    // }


    /*----------------------------------------------
    Wrap iframes in div .iframe-container to make them full width
    ------------------------------------------------*/
    $('.article--body iframe').wrap('<div class="iframe-container"></div>');


    // let init = () => {
    //     var swup = new Swupjs(options);
    // }
    // return {
    //     init: init
    // }
    // }();

    ///////////////////
    // INIT SWUPS   ///
    ///////////////////
    // pageTransitions.init();


    ///////////////////
    // INIT SCRIPTS ///
    ///////////////////
    scriptInit();
    // alert('bosh');

});